<template>
  <div class="checkbox flex flex-col gap-2" :class="{ 'checkbox--error': error }">
    <label class="checkbox__label flex items-start gap-2 cursor-pointer" :for="id">
      <div class="checkbox__wrapper relative">
        <input
          :id="id"
          :name="name"
          :required="required"
          :tabindex="tabindex"
          :aria-invalid="error ? 'true' : 'false'"
          :aria-describedby="error ? `${id}-error` : undefined"
          type="checkbox"
          v-model="checkboxValue"
          class="checkbox__input sr-only"
          :class="{ 'checkbox__input--error': error }"
        />
        <div
          class="checkbox__custom flex size-[18px] mt-1 items-center justify-center rounded-[2px] bg-white border border-primary transition-all duration-200"
          :class="{
            'checkbox__custom--checked': checkboxValue,
            'checkbox__custom--error': error,
            'hover:bg-neutral-lightest focus-within:shadow-[0_0_0_2px_black]': !error,
          }"
        >
          <svg
            v-if="checkboxValue"
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="12"
            viewBox="0 0 14 12"
            fill="currentColor"
            class="checkbox__check"
          >
            <path
              d="M4.57181 8.65405L1.37339 5.45563L0 6.82902L4.57181 11.4008L14 1.97263L12.6266 0.599243L4.57181 8.65405Z"
              fill="white"
            />
          </svg>
        </div>
      </div>
      <span class="checkbox__label-text text-small-normal" :class="{ '!text-[#CF2402]': error }">
        <slot />
        <span class="checkbox__label-text-required" v-if="required" aria-hidden="true">*</span>
      </span>
    </label>
    <p class="checkbox__error text-small-normal !text-[#CF2402]" v-if="error" :id="`${id}-error`">
      {{ error }}
    </p>
  </div>
</template>

<script setup lang="ts">
  const checkboxValue = computed({
    get: () => props.modelValue,
    set: (value: boolean) => {
      emit('update:modelValue', value);
    },
  });

  const props = defineProps<{
    modelValue: boolean;
    error?: string;
    id?: string;
    name?: string;
    required?: boolean;
    tabindex?: number;
  }>();

  const emit = defineEmits<{
    (e: 'update:modelValue', value: boolean): void;
  }>();
</script>

<style scoped>
  .checkbox__custom--checked {
    background-color: #23b7ac;
    border-color: #23b7ac;
  }

  .checkbox__custom--error {
    border-color: #cf2402;
  }

  .checkbox__custom--error.checkbox__custom--checked {
    background-color: #cf2402;
    border-color: #cf2402;
  }
</style>
